export const OfflineDeviceControllerFactory = ({
  offlineDeviceService,
}: {
  offlineDeviceService: IOfflineDeviceService;
}) => {
  const postDeviceIssue: IPostDeviceIssue = async ({
    clinicId,
    deviceId,
    roomName,
    issues,
    comments,
    pictures,
  }) => {
    const response = await offlineDeviceService.postDeviceIssue({
      clinicId,
      deviceId,
      roomName,
      issues,
      comments,
      pictures,
    });
    return response;
  };

  const getOfflineDeviceList: IGetOfflineDeviceList = async ({
    clinicId,
    floorIds,
  }) => {
    const response = await offlineDeviceService.getOfflineDevicelist({
      clinicId,
      floorIds,
    });

    if (response.data) {
      const sorted = response.data.data.sort((a, b) => {
        if (a.name === null || b.name === null) return 0;
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      return { data: { data: sorted }, success: true };
    }
    return response;
  };

  const getAllDeviceList: IGetAllDeviceList = async ({
    clinicId,
    floorIds,
  }) => {
    const response = await offlineDeviceService.getAllDevicelistService({
      clinicId,
      floorIds,
    });

    if (response.data) {
      const sorted = response.data.data.sort((a, b) => {
        if (a.name === null || b.name === null) return 0;
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      return { data: { data: sorted }, success: true };
    }
    return response;
  };

  return {
    getOfflineDeviceList,
    getAllDeviceList,
    postDeviceIssue,
  };
};
